import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SingleSelectField = ({
  IconColor,
  name,
  fullWidth = true,
  placeholder = "",
  error,
  disabled = false,

  // Select Styles
  selectFontSize = "14px",
  selectLineHeight = "14px",
  selectFontWeight = 400,
  selectColor = "#667F93",
  selectPadding = "13px 20px",
  selectBorderRadius = "10px",
  selectBackgroundColor = "",
  selectBorder = "none",
  selectMarginTop = "11px",
  placeholderColor = "#667F93",

  // Dropdown Menu Styles
  dropdownItemPadding = "10px",
  dropdownItemFontSize = { sm: "10px", md: "12px", lg: "16px" },
  dropdownItemColor = "#667F93",
  dropdownItemMargin = "0",
  dropdownItemBorderRadius = "0px",
  dropdownItemFontWeight = 400,
  // Options
  options = [],
  value,
  onChange,
  onBlur,
  sx,
  disablePortal = false,
  loading,
}) => {
  const selectStyles = {
    marginTop: selectMarginTop,
    "& .MuiOutlinedInput-notchedOutline": {
      border: selectBorder,
      borderRadius: selectBorderRadius,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderRadius: selectBorderRadius,
    },
    "& .MuiSelect-select": {
      fontSize: selectFontSize,
      lineHeight: selectLineHeight,
      fontWeight: selectFontWeight,
      color: selectColor || "inherit",
      padding: selectPadding,
      borderRadius: selectBorderRadius,
      backgroundColor: selectBackgroundColor || "transparent",
      whiteSpace: "nowrap",
      overflow: "visible",
      textOverflow: "unset",
      minWidth: "max-content",
      "&:focus, &[aria-expanded='true']": {
        backgroundColor: "transparent",
      },
    },
  };

  const menuItemStyles = {
    padding: {
      sm: "10px 16px",
      md: "12px 16px",
      lg: "14px 20px",
    },
    fontSize: dropdownItemFontSize,
    color: dropdownItemColor,
    margin: 0,
    borderRadius: 0,
    fontWeight: dropdownItemFontWeight,
    borderBottom: "1px solid #D9E1E7",
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      backgroundColor: "#FFFFFF !important",
    },
    "&.Mui-selected": {
      backgroundColor: "#FFFFFF !important",
      color: dropdownItemColor,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "transparent !important",
    },
    "&.Mui-selected.Mui-focusVisible": {
      backgroundColor: "transparent !important",
    },
  };

  return (
    <div>
      <FormControl fullWidth={fullWidth} sx={sx}>
        <Select
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          displayEmpty
          sx={selectStyles}
          error={error}
          IconComponent={(props) => (
            <KeyboardArrowDownIcon style={{ color: IconColor }} {...props} />
          )}
          disabled={disabled}
          renderValue={(selected) => {
            if (!selected || selected === "") {
              return (
                <span style={{ color: placeholderColor, whiteSpace: "nowrap" }}>
                  {placeholder}
                </span>
              );
            }
            const selectedOption = options.find(
              (option) => option.value === selected,
            );
            return selectedOption ? selectedOption.label : "No value";
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: "16px",
                marginTop: "8px",
                maxHeight: 300,
                overflowY: "auto",
                background: "linear-gradient(180deg, #EAF2FF 0%, #FFFFFF 100%)",
                border: "1px solid #C2D9F0",
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
                "& .MuiList-root": {
                  padding: 0,
                },
              },
            },
            disablePortal: disablePortal,
          }}
        >
          {loading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : options.length === 0 ? (
            <MenuItem disabled>No {name || "options"} found</MenuItem>
          ) : (
            options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                sx={menuItemStyles}
                disabled={option.disabled}
              >
                {option.label}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default SingleSelectField;
